import type { FC } from "react";
import Routes from "../../../routes";
import { AlertMessageConditions } from "../types";
import { AlertMessageLink } from "../../../../components/AlertMessage/AlertMessageLink";
import type { AlertMessageLinkWrapperProps } from "./types";

export const DefaultOneSavedPharmacyStaleAccountLink: FC<
  AlertMessageLinkWrapperProps
> = ({ children, ...props }) => {
  return (
    <AlertMessageLink
      {...props}
      to={Routes.summary.managePharmacies}
      condition={AlertMessageConditions.ONE_SAVED_PHARMACY_STALE_ACCOUNT}
    >
      {children}
    </AlertMessageLink>
  );
};

export const OneSavedPharmacyStaleAccountLink: FC<
  AlertMessageLinkWrapperProps
> = ({ children, alertMessageContext, ...props }) => {
  const hasPlan = !!alertMessageContext.planId;
  const inNetworkPharmacyFinderLink = Routes.inNetworkPharmacy.replace(
    ":id",
    alertMessageContext?.planId || ""
  );
  const summaryPageAddPharmaciesLink = hasPlan
    ? inNetworkPharmacyFinderLink
    : Routes.pharmacy;
  return (
    <AlertMessageLink
      {...props}
      condition={AlertMessageConditions.ONE_SAVED_PHARMACY_STALE_ACCOUNT}
      to={{
        pathname: alertMessageContext.isFromSummaryPage
          ? summaryPageAddPharmaciesLink
          : inNetworkPharmacyFinderLink,
        search: alertMessageContext?.search,
        state: alertMessageContext?.routerState,
      }}
    >
      {children}
    </AlertMessageLink>
  );
};
